<template>
    <div class="mt-3">
        <div class="col-xs-12 col-md-12 text-center">
            <button class="btn btn-sm transition transition-all duration-300 ease-out"
                :class="downloading ? 'animate-pulse focus:outline-none hover:border-green-500 hover:bg-green-500 bg-green-500' : 'bg-indigo-500'"
                :style="{ minWidth: downloading ? '100%' : '0' }"
                v-html="button_html"
                @click="generate"
            >
            </button>
        </div>

        <div ref="content" class="text-sm printablehandout">
            <slot></slot>
        </div>
  </div>
</template>

<script>
import axios from 'axios';
import download from 'downloadjs';

export default {
    props: {
        name: {},
        buttontext: {
            default: 'Generate PDF'
        },
    },

    data() {
        return {
            button_html: this.buttontext,
            downloading: false,
        }
    },

    methods: {
        generate() {
            let content = this.$refs.content.innerHTML;
            this.downloading = true;
            this.button_html = 'Generating PDF ...';

            axios.post('/pdf-download', {
                name: this.name,
                content: content,
            }, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                },
            }).then(response => {
                const content = response.headers['content-type'];
                download(response.data, response.headers['x-filename'] || 'download.pdf', content);
                this.downloading = false;
                this.button_html = 'Download Complete';
            }).catch(error => {
                this.downloading = false;
                this.button_html = 'Download Error';
                console.log(error);
            });
        }
    },
};
</script>
